import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cc0021',
    ecrans: [
        '00-2',
        '01-2'
    ]
});
